import apiHelper from './apiHelper';

const authApi = {

    Login: async ({ param, success }) => {
        return await apiHelper.exec({
            url: apiHelper.createUrl({
                template: "api/Account/login",
                serverurl: apiHelper.getIdentityServerUrl()
            }), method: "POST", param, success
        });
    }
}

export default authApi;